<script setup lang="ts">
import {ref, toRef, watch} from "vue";
defineOptions({
    inheritAttrs: false,
});
const props = defineProps({
    value: {
        type: [String, null],
        default: "",
    },
    modelValue: {
        type: [File, String, null],
        default: "",
    },
    name: {
        type: String,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
        required: false,
    },
    error: {
        type: String,
        default: null,
    },
});

const fileValue = ref("");

const emit = defineEmits(["update:modelValue"]);

const name = toRef(props, "name");
const file = ref<File | null>();
const handleFileUpload = (event) => {
    fileValue.value = event.target.files[0].name;
    emit("update:modelValue", event.target.files[0]);
};

watch(
    () => props.modelValue,
    (newValue, oldValue) => {
        if (newValue == "" || newValue == null) {
            (file.value as any).value = null;
        }
    },
    {deep: true}
);
</script>

<template>
    <input
        :name="name"
        ref="file"
        :id="name"
        type="file"
        class="form-control"
        :class="{'is-invalid': !!error}"
        :placeholder="placeholder"
        :disabled="disabled"
        @change="handleFileUpload($event)" />
    <span
        class="invalid-feedback"
        role="alert"
        v-if="error">
        {{ error }}
    </span>
</template>
